// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';
import { Flex } from '@atlassian/eoc-flex';

const maxInputWidth = `${8 * 44}px`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ConditionFilterWrapper = styled.div({
	marginTop: token('space.150', '12px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'#condition-filter-match-type': {
		maxWidth: maxInputWidth,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SelectWrapper = styled.div({
	maxWidth: maxInputWidth,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RadioWrapper = styled.div({
	marginTop: token('space.200', '16px'),
	marginLeft: token('space.200', '16px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	"div[role='radiogroup']": {
		display: 'flex',
		columnGap: token('space.300', '24px'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TimePickerWrapper = styled.div({
	width: '100%',
	maxWidth: `${8 * 20.75}px`,
	marginTop: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TimezoneWrapper = styled.div({
	width: '100%',
	maxWidth: `${8 * 20.75 * 2 + 8}px`,
	marginTop: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DayTimeIntervalWrapper = styled(Flex)({
	width: '100%',
	maxWidth: `${8 * 62}px`,
	marginTop: token('space.250', '20px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SectionMessageWrapper = styled.div({
	marginTop: token('space.100', '8px'),
});
